import React from 'react'
import { Link } from '@common/material'
import { TimelineBlockBase } from '@common/Timeline'
import { Text } from '@fundamentals'

type ComponentProps = {
  title: string
  href: string
  text: string
  subText?: string
}

export const TimelineLinkBlock: React.FC<ComponentProps> = ({
  title,
  href,
  text,
  subText,
}) => {
  return (
    <TimelineBlockBase title={title}>
      <Link href={href}>
        <Text variant='body2'>{text}</Text>
      </Link>
      {subText && (
        <Text color='text.secondary' fontSize={12}>
          {subText}
        </Text>
      )}
    </TimelineBlockBase>
  )
}
